import { render, staticRenderFns } from "./left-nav.vue?vue&type=template&id=2a9f1ba9&"
import script from "./left-nav.vue?vue&type=script&lang=ts&"
export * from "./left-nav.vue?vue&type=script&lang=ts&"
import style0 from "./left-nav.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports